import { numberCheck } from "./dataProcess";
import { FRAME_SIZE } from '../../pages/Sierra/constants';
import { TOLERANCE } from "../Rocky/constants";

const ErrorMsg = [
  "Please set the plot width from 1 to 2.", //0
  'Value must be greater than 0 and less than 1.',// >0 <1
]

function eyeDiagramErrorCheckIndex({ value, inputType }) {

  let errorIndex = -1;

  switch (inputType) {
    case FRAME_SIZE:
      if (parseFloat(value) > 2 || parseFloat(value) < 1) {
        errorIndex = 0;
      };
      break;
    case TOLERANCE:
      if (parseFloat(value) <= 0 || parseFloat(value) >= 1) {
        errorIndex = 1;
      }
      break;
    default: errorIndex = -1; break;
  };

  return errorIndex;
}

function eyeDiagramErrorCheck({ value, inputType }) {
  let notNum = numberCheck(value, true);
  if (notNum) {
    return notNum;
  }
  const index = eyeDiagramErrorCheckIndex({ value, inputType });
  if (index > -1) {
    return ErrorMsg[index];
  } else {
    return null;
  }
}

export { eyeDiagramErrorCheck, eyeDiagramErrorCheckIndex }; 